import React from 'react';
import * as _ from 'lodash';

const toDelete = count => (count === 1 ? 'one' : `${count} of them`);

/*
  How many runs the chosen sandbox keeps, of how many it may: the backend refuses a run that would pass `maxRunsPerWorkspace`
  (legaleyse-backend#105), counting the runs of the sandbox in any state, and asks the user to delete some first. This says so before
  the user tries; the server is still the one that refuses, and the button is not disabled.

  `places` are the runs that are asked for: a test of a change plays two, and is refused as a whole when only one place is left.
  Nothing is said by a backend that does not send the limit.
*/
export const SandboxRunsNote = ({
    limits,
    workspace,
    places = 1,
    onOpenRuns
}) => {
    const max = _.get(limits, 'maxRunsPerWorkspace');
    const kept = _.get(workspace, 'runCount');

    if (_.isNil(max) || _.isNil(kept)) {
        return null;
    }
    const missing = kept + places - max;

    if (missing <= 0) {
        return (
            <div className={'sim-muted'} style={{ marginTop: 8 }}>
                {kept} of {max} runs kept in this sandbox.
            </div>
        );
    }

    return (
        <div className={'sim-banner warning'} style={{ marginTop: 12 }}>
            <i className={'material-icons'}>warning</i>
            <div>
                This sandbox keeps {kept} of {max} runs.{' '}
                {places > 1
                    ? `A test of a change plays ${places} runs, and is refused until you delete `
                    : 'A new run is refused until you delete '}
                {toDelete(missing)}.
                {onOpenRuns && (
                    <span>
                        {' '}
                        <button
                            type={'button'}
                            className={'sim-link'}
                            onClick={onOpenRuns}
                        >
                            Open the runs
                        </button>
                    </span>
                )}
            </div>
        </div>
    );
};
